import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateObraArquivoUseCase } from "../../../presentation/useCases/update/update_obra_arquivo_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * Enum Status
 */

enum ObraArquivoStatus {
  ATIVO = 1,
  OBSOLETO = 2,
}

/**
 * UpdateObraArquivoUseCase
 */

export class UpdateObraArquivoUseCase implements IUpdateObraArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateObraArquivo(
    idObraArquivo: number,
    statusArquivo: number,
    nomeDocumento: string,
    file: File | null,
    dataVencimento: Date | null,
  ): Promise<void> {
    const obsoleto = statusArquivo === ObraArquivoStatus.OBSOLETO;
    const arquivo = await FileUtils.readFileAsBase64(file);
    const arquivoNome = file !== null ? file.name : null;

    await this.repository.updateObraArquivo(
      idObraArquivo,
      obsoleto,
      nomeDocumento,
      arquivoNome,
      arquivo,
      dataVencimento,
    );
  }
}
